import styled from 'styled-components'

type TypeButton ={
    text?:string
    color?: string
    valid?:boolean
}



const PageInput = styled.input<TypeButton>`
    width: 40px;
    height: 40px;
    border-radius:5px;
    border: 2px solid ${props => props.valid?props.color:"#FF1515"};
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: 0em;
    text-align: center;
    outline: none;
    font-family: Open Sans;
`
const PaginateText = styled.div`
    display: flex;
    align-items: center;
    padding: 10px;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: 0em;
`

const PaginateInvalidText = styled.div`
    display: flex;
    align-items: center;
    justify-content:center;
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 14px;
    color:#FF1515;
`


const ButtonNext = styled.div<TypeButton>`
    font-family: Open Sans;
    font-weight: bold;
    font-size: 16px;
    color:#FFFFFF;
    background: ${props => props.color};
    height: 40px;
    width: 115px;
    border-color: ${props => props.color};
    margin-left: 15px;
    border-radius: 6px;
    cursor: pointer;
    border-width: 3px;
    text-align: center;
    padding: 5px;
    align-items: center;
    justify-content: center;
    display:flex;
    &:focus{
         border-color: ${props => props.color};
         outline: 0 none;
    };
    @media (max-width: ${props => props.theme.breakpoints.md}){
       width: 30px;      
    }
`

const ButtonPrevius = styled.div<TypeButton>`
    font-family: Open Sans;
    font-weight: bold;
    font-size: 16px;
    color: ${props => props.color};
    height: 40px;
    width: 115px;
    align-items: center;
    justify-content: center;
    color:#FFFFFF;
    background: ${props => props.color};
    border-radius: 6px;
    cursor: pointer;
    display:flex;
    text-align: center;
    padding: 5px;
    &:focus{
     border-color: ${props => props.color};
     outline: 0 none;
    };
     @media (max-width: ${props => props.theme.breakpoints.md}){
        width: 30px;      
    }
`

const PaginateSelected = styled.p<TypeButton>`
    margin-left: 15px;
    margin-right: 20px;
    margin-top: 0;
    font-weight: bold;
    cursor: pointer;
    color: white;
    background: ${props => props.color};
    border-radius: 5px;
    padding: 8px;
     @media (max-width: ${props => props.theme.breakpoints.md}){
       margin-right: 0;    
    }
`

const Paginate = styled.p<TypeButton>`
    margin-left: 15px;
    margin-right: 20px;
    margin-top: 9px;
    font-weight: bold;
    cursor: pointer;
    color: ${props => props.color};
`

const ContainerPaginate = styled.div`
    display: flex;
    justify-content: center;
    align-items:center;
    margin-top: 70px;
     @media (max-width: ${props => props.theme.breakpoints.md}){
        margin-top: 0;      
    }
`

export {PaginateInvalidText,PaginateText,PageInput,ButtonNext, ButtonPrevius, PaginateSelected, Paginate, ContainerPaginate}